import { cn } from '@/lib/cn'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  header?: React.ReactNode
  footer?: React.ReactNode
  contentClassName?: string
  children: React.ReactNode
}

/**
 * Card container with optional header and footer slots.
 */
export const Card = ({
  header,
  footer,
  contentClassName,
  children,
  className,
  ...rest
}: CardProps): React.ReactElement => {
  return (
    <div
      className={cn(
        'min-w-0 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800',
        className
      )}
      {...rest}
    >
      {header && (
        <div className="border-b border-gray-200 px-6 py-5 dark:border-gray-700">
          {header}
        </div>
      )}
      <div className={cn('min-w-0 p-4', contentClassName)}>{children}</div>
      {footer && (
        <div className="border-t border-gray-200 px-4 py-3 dark:border-gray-700">
          {footer}
        </div>
      )}
    </div>
  )
}
